import actions from './actions';


const initState = {
    consumerInfo: {}
}


export default function consumerPatientReducer(state = initState, action) {
    switch (action.type) {
        case action.PATIENT_INFO_LOAD_SUCCESS:
            console.log('in readucer')
            const {id, data} = action.payload;
            return {...state, ...{[id]: data }}
        default:
            return state;
    }
    return state;
}

